/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfInteger } from '../models/custom-result-of-integer';
import { CustomResultOfListOfDownloadAllPrivateNumberBuyRequestDocumentsDto } from '../models/custom-result-of-list-of-download-all-private-number-buy-request-documents-dto';
import { CustomResultOfPaginatedListOfChildrenPrivateNumberBuyRequestsPaginationDto } from '../models/custom-result-of-paginated-list-of-children-private-number-buy-requests-pagination-dto';
import { CustomResultOfPaginatedListOfGetPrivateNumberBuyRequestsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-private-number-buy-requests-with-pagination-dto';
import { privateNumberBuyRequestCreateGet } from '../fn/private-number-buy-request/private-number-buy-request-create-get';
import { PrivateNumberBuyRequestCreateGet$Params } from '../fn/private-number-buy-request/private-number-buy-request-create-get';
import { privateNumberBuyRequestCreatePost } from '../fn/private-number-buy-request/private-number-buy-request-create-post';
import { PrivateNumberBuyRequestCreatePost$Params } from '../fn/private-number-buy-request/private-number-buy-request-create-post';
import { privateNumberBuyRequestDelete } from '../fn/private-number-buy-request/private-number-buy-request-delete';
import { PrivateNumberBuyRequestDelete$Params } from '../fn/private-number-buy-request/private-number-buy-request-delete';
import { privateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments } from '../fn/private-number-buy-request/private-number-buy-request-download-all-private-number-buy-request-documents';
import { PrivateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments$Params } from '../fn/private-number-buy-request/private-number-buy-request-download-all-private-number-buy-request-documents';
import { privateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination } from '../fn/private-number-buy-request/private-number-buy-request-get-children-private-number-buy-requests-pagination';
import { PrivateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination$Params } from '../fn/private-number-buy-request/private-number-buy-request-get-children-private-number-buy-requests-pagination';
import { privateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination } from '../fn/private-number-buy-request/private-number-buy-request-get-private-number-buy-requests-with-pagination';
import { PrivateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination$Params } from '../fn/private-number-buy-request/private-number-buy-request-get-private-number-buy-requests-with-pagination';
import { privateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination } from '../fn/private-number-buy-request/private-number-buy-request-get-private-number-prices-audit-with-pagination';
import { PrivateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination$Params } from '../fn/private-number-buy-request/private-number-buy-request-get-private-number-prices-audit-with-pagination';
import { privateNumberBuyRequestPrivateNumberBuyRequestDocumentLink } from '../fn/private-number-buy-request/private-number-buy-request-private-number-buy-request-document-link';
import { PrivateNumberBuyRequestPrivateNumberBuyRequestDocumentLink$Params } from '../fn/private-number-buy-request/private-number-buy-request-private-number-buy-request-document-link';
import { privateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus } from '../fn/private-number-buy-request/private-number-buy-request-update-private-number-buy-documents-status';
import { PrivateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus$Params } from '../fn/private-number-buy-request/private-number-buy-request-update-private-number-buy-documents-status';
import { privateNumberBuyRequestUpdateStatus } from '../fn/private-number-buy-request/private-number-buy-request-update-status';
import { PrivateNumberBuyRequestUpdateStatus$Params } from '../fn/private-number-buy-request/private-number-buy-request-update-status';
import { privateNumberBuyRequestUploadPrivateNumberBuyDocuments } from '../fn/private-number-buy-request/private-number-buy-request-upload-private-number-buy-documents';
import { PrivateNumberBuyRequestUploadPrivateNumberBuyDocuments$Params } from '../fn/private-number-buy-request/private-number-buy-request-upload-private-number-buy-documents';

@Injectable({ providedIn: 'root' })
export class PrivateNumberBuyRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `privateNumberBuyRequestCreateGet()` */
  static readonly PrivateNumberBuyRequestCreateGetPath = '/PrivateNumberBuyRequest/Create';

  /**
   * ایجاد(بررسی دسترسی).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberBuyRequestCreateGet$Response(params?: PrivateNumberBuyRequestCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return privateNumberBuyRequestCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد(بررسی دسترسی).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberBuyRequestCreateGet(params?: PrivateNumberBuyRequestCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.privateNumberBuyRequestCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestCreatePost()` */
  static readonly PrivateNumberBuyRequestCreatePostPath = '/PrivateNumberBuyRequest/Create';

  /**
   * خرید خط.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestCreatePost$Response(params: PrivateNumberBuyRequestCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfInteger>> {
    return privateNumberBuyRequestCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * خرید خط.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestCreatePost(params: PrivateNumberBuyRequestCreatePost$Params, context?: HttpContext): Observable<CustomResultOfInteger> {
    return this.privateNumberBuyRequestCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfInteger>): CustomResultOfInteger => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestUpdateStatus()` */
  static readonly PrivateNumberBuyRequestUpdateStatusPath = '/PrivateNumberBuyRequest/UpdateStatus';

  /**
   * ویرایش وضعیت فقط توسط کاربران سازمان پیشگام رایان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestUpdateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestUpdateStatus$Response(params: PrivateNumberBuyRequestUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberBuyRequestUpdateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش وضعیت فقط توسط کاربران سازمان پیشگام رایان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestUpdateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestUpdateStatus(params: PrivateNumberBuyRequestUpdateStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberBuyRequestUpdateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestDelete()` */
  static readonly PrivateNumberBuyRequestDeletePath = '/PrivateNumberBuyRequest/Delete';

  /**
   * حذف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestDelete$Response(params: PrivateNumberBuyRequestDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberBuyRequestDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestDelete(params: PrivateNumberBuyRequestDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberBuyRequestDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination()` */
  static readonly PrivateNumberBuyRequestGetPrivateNumberBuyRequestsWithPaginationPath = '/PrivateNumberBuyRequest/GetPrivateNumberBuyRequestsWithPagination';

  /**
   * دریافت درخواست های خرید هر سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination$Response(params: PrivateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPrivateNumberBuyRequestsWithPaginationDto>> {
    return privateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت درخواست های خرید هر سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination(params: PrivateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPrivateNumberBuyRequestsWithPaginationDto> {
    return this.privateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPrivateNumberBuyRequestsWithPaginationDto>): CustomResultOfPaginatedListOfGetPrivateNumberBuyRequestsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination()` */
  static readonly PrivateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPaginationPath = '/PrivateNumberBuyRequest/GetChildrenPrivateNumberBuyRequestsPagination';

  /**
   * لیست درخواست های خرید خط برای بررسی و به روز رسانی وضعیت فقط توسط کاربران پیشگام.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination$Response(params: PrivateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfChildrenPrivateNumberBuyRequestsPaginationDto>> {
    return privateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست درخواست های خرید خط برای بررسی و به روز رسانی وضعیت فقط توسط کاربران پیشگام.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination(params: PrivateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfChildrenPrivateNumberBuyRequestsPaginationDto> {
    return this.privateNumberBuyRequestGetChildrenPrivateNumberBuyRequestsPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfChildrenPrivateNumberBuyRequestsPaginationDto>): CustomResultOfPaginatedListOfChildrenPrivateNumberBuyRequestsPaginationDto => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination()` */
  static readonly PrivateNumberBuyRequestGetPrivateNumberPricesAuditWithPaginationPath = '/PrivateNumberBuyRequest/GetPrivateNumberPricesAuditWithPagination';

  /**
   * دریافت گزارش Audit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination$Response(params: PrivateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return privateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت گزارش Audit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination(params: PrivateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.privateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments()` */
  static readonly PrivateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocumentsPath = '/PrivateNumberBuyRequest/DownloadAllPrivateNumberBuyRequestDocuments';

  /**
   * Download All PrivateNumber Buy Request Documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments$Response(params?: PrivateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfDownloadAllPrivateNumberBuyRequestDocumentsDto>> {
    return privateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * Download All PrivateNumber Buy Request Documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments(params?: PrivateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments$Params, context?: HttpContext): Observable<CustomResultOfListOfDownloadAllPrivateNumberBuyRequestDocumentsDto> {
    return this.privateNumberBuyRequestDownloadAllPrivateNumberBuyRequestDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfDownloadAllPrivateNumberBuyRequestDocumentsDto>): CustomResultOfListOfDownloadAllPrivateNumberBuyRequestDocumentsDto => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestPrivateNumberBuyRequestDocumentLink()` */
  static readonly PrivateNumberBuyRequestPrivateNumberBuyRequestDocumentLinkPath = '/PrivateNumberBuyRequest/PrivateNumberBuyRequestDocumentLink';

  /**
   * Download PrivateNumberBuyRequest Document Link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestPrivateNumberBuyRequestDocumentLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberBuyRequestPrivateNumberBuyRequestDocumentLink$Response(params?: PrivateNumberBuyRequestPrivateNumberBuyRequestDocumentLink$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return privateNumberBuyRequestPrivateNumberBuyRequestDocumentLink(this.http, this.rootUrl, params, context);
  }

  /**
   * Download PrivateNumberBuyRequest Document Link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestPrivateNumberBuyRequestDocumentLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberBuyRequestPrivateNumberBuyRequestDocumentLink(params?: PrivateNumberBuyRequestPrivateNumberBuyRequestDocumentLink$Params, context?: HttpContext): Observable<Blob> {
    return this.privateNumberBuyRequestPrivateNumberBuyRequestDocumentLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus()` */
  static readonly PrivateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatusPath = '/PrivateNumberBuyRequest/UpdatePrivateNumberBuyDocumentsStatusCommand';

  /**
   * به روز رسانی وضعیت و توضیحات مدارک توسط مدیر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus$Response(params: PrivateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * به روز رسانی وضعیت و توضیحات مدارک توسط مدیر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus(params: PrivateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberBuyRequestUpdatePrivateNumberBuyDocumentsStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumberBuyRequestUploadPrivateNumberBuyDocuments()` */
  static readonly PrivateNumberBuyRequestUploadPrivateNumberBuyDocumentsPath = '/PrivateNumberBuyRequest/UploadPrivateNumberBuyDocuments';

  /**
   * آپلود مدارک توسط کاربر فقط در حالت منتظر آپلود مدارک.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberBuyRequestUploadPrivateNumberBuyDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestUploadPrivateNumberBuyDocuments$Response(params: PrivateNumberBuyRequestUploadPrivateNumberBuyDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberBuyRequestUploadPrivateNumberBuyDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * آپلود مدارک توسط کاربر فقط در حالت منتظر آپلود مدارک.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberBuyRequestUploadPrivateNumberBuyDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberBuyRequestUploadPrivateNumberBuyDocuments(params: PrivateNumberBuyRequestUploadPrivateNumberBuyDocuments$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberBuyRequestUploadPrivateNumberBuyDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
